// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ThemeContext__Theme$PrezzeeRibbon from "./ThemeContext__Theme.bs.js";

var defaultTheme = ThemeContext__Theme$PrezzeeRibbon.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var context = React.createContext(defaultTheme);

function useTheme(param) {
  return React.useContext(context);
}

var provider = context.Provider;

function ThemeContext$Provider(props) {
  var value = props.value;
  var initValue = value !== undefined ? value : ThemeContext__Theme$PrezzeeRibbon.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  return React.createElement(provider, {
              value: initValue,
              children: props.children
            });
}

var Provider = {
  provider: provider,
  make: ThemeContext$Provider
};

var Theme;

var Components;

export {
  Theme ,
  Components ,
  defaultTheme ,
  context ,
  useTheme ,
  Provider ,
}
/* defaultTheme Not a pure module */
